const REGEX_PRODUCT_NUMBER =
    /(?<productCode>\d{3})-(?<versionCode>\d{3})-(?<designVariantCode>\d{4})-(?<regionCode>\d{2})-(?<customerCode>\d{2})/;

type ProductNumberProperties = {
    productCode: string;
    versionCode: string;
    designVariantCode: string;
    regionCode: string;
    customerCode: string;
};

export function extractPropertiesFromProductNumber(pn: string): ProductNumberProperties | null {
    const match = pn.match(REGEX_PRODUCT_NUMBER);

    if (match === null) {
        return null;
    }

    const { productCode, versionCode, designVariantCode, regionCode, customerCode } = match.groups!;

    if (
        typeof productCode === 'undefined' ||
        typeof versionCode === 'undefined' ||
        typeof designVariantCode === 'undefined' ||
        typeof regionCode === 'undefined' ||
        typeof customerCode === 'undefined'
    ) {
        return null;
    }

    return { productCode, versionCode, designVariantCode, regionCode, customerCode };
}
